/*eslint-disable*/
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@synergy-marine-group/synergy-ui';
import Modal from 'react-responsive-modal';
import { CircularProgress } from '@material-ui/core';
import ButtonComponent from '../common/ButtonComponent';
import FilterComponent from '../common/FilterComponent';
import Header from '../common/Header';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';
import PoTableComponent from './PoTableComponent';
import { deleteModalStyles } from '../Modal/styles';
import plusIcon from '../../images/icons/plus_icon.svg';
import exportPOs from './queries/exportPOs';
import exportCommitedPOs from './queries/exportCommitedPOs';
import PoFilter from '../Modal/PoFilter';
import { resetFilter, updateFliter } from '../../features/fliter/filterSlice';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { updatepage } from '../../features/pagecount/pageSlice';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import { AuthContext } from '../providers/AuthProvider';
import DropdownSelect from '../common/DropdownSelect';
import { Switch, FormControlLabel, Select, MenuItem, FormControl } from '@material-ui/core';
import { update } from 'lodash';
import { updatePage } from '../../features/pageHandle';
import CreatePOButton from './CreatePOButton';
import ExportCCVButton from './ExportCCVButton';

const ManningPOBasePage = () => {
  const [modal, setModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [exportValue, setExportValue] = useState(null);
  const filterData = useSelector((state) => state.filter.filterData);
  const dispatch = useDispatch();
  const [search, setsearch] = useState(filterData?.search);
  const [isAssignedToMe, setIsAssignedToMe] = useState(true);
  const [activeTab, setActiveTab] = useState(filterData.poStatus);
  const [isShortCloseCompleted, setIsShortCloseCompleted] = useState(false);
  const [isVendor, setIsVendor] = useState(true);
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [assigneDropDownSelect, setAssigneDropDownSelect] = useState('');
  const history = useHistory();
  const policies = returnPolicies();
  const { getUser } = useContext(AuthContext);
 const isCrewPage = useSelector((state) => state.pageHandler.pageSetter.isCrewPage);
  const poListType = useSelector((state) => state.pageHandler.pageSetter.poListType) || (isCrewPage ? 'crew' : 'vessel');

  const goToCreatePage = () => {
    history.push('/create-po');
  };

  const { mutate: exportPo, isLoading: exportPOLoading } = exportPOs();
  const { mutate: exportCommitedPo, isLoading: exportCommitedPOsLoading } = exportCommitedPOs();

  const tabChange = (tab) => {
    setActiveTab(tab);
    if (!isVendor) {
      dispatch(updateFliter({ ...filterData, poStatus: tab }));
    }
    dispatch(updatepage(1));
  };
  const handlleExportCommited = (type) => {
    setExportValue('ccr');
    // change filterdata headers
    const filData = {
      crewCode: filterData?.crewID,
      plannedVesselId: filterData?.vessel,
      plannedVesselRevisionId: filterData?.plannedVesselRevisionId,
      vendorId: filterData?.vendor,
      poInitiator: filterData?.poInitiator,
      poStatus: filterData?.poStatus,
      invoiceStatus: filterData?.invoiceStatus,
      vesselOwner: filterData?.vesselOwner,
      budgetCategory: filterData?.budgetCategory,
      expenseCategoryId: filterData?.expenseCategoryId,
      pocategory: type?.includes('vessel') ? '1' : type?.includes('crew') ? '0' : type?.includes('agency') ? '2' : null,
      toDate: filterData?.todate,
      fromDate: filterData?.fromdate,
      ...(type?.includes('agency') && {
        serviceCompletionFromDate: filterData?.serviceFromDate || undefined,
        serviceCompletionToDate: filterData?.serviceToDate || undefined
      }),
      search
    };
    const isEmpty = Object.values(filData).every((x) => x === null || x === '' || x === undefined);
    if (!isEmpty) {
      exportCommitedPo(filData);
    } else {
      setFilterModal(true);
    }
  };
  const handlleExport = (type) => {
    setExportValue('csv');
    // change filterdata headers
    const filData = {
      crewCode: filterData?.crewID,
      plannedVesselId: filterData?.vessel,
      plannedVesselRevisionId: filterData?.plannedVesselRevisionId,
      vendorId: filterData?.vendor,
      poStatus: filterData?.poStatus,
      poInitiator: filterData?.poInitiator,
      invoiceStatus: filterData?.invoiceStatus,
      vesselOwner: filterData?.vesselOwner,
      budgetCategory: filterData?.budgetCategory,
      expenseCategoryId: filterData?.expenseCategoryId,
      pocategory: type?.includes('vessel') ? '1' : type?.includes('crew') ? '0' : type?.includes('agency') ? '2' : null,
      toDate: filterData?.todate,
      fromDate: filterData?.fromdate,
      ...(type?.includes('agency') && {
        serviceCompletionFromDate: filterData?.serviceFromDate || undefined,
        serviceCompletionToDate: filterData?.serviceToDate || undefined,
        // isAdvancePO
      }),
      search
    };
    const isEmpty = Object.values(filData).every((x) => x === null || x === '' || x === undefined);
    if (!isEmpty) {
      exportPo(filData);
    } else {
      setFilterModal(true);
    }
  };
  useEffect(() => {
    dispatch(resetFilter());
    const val = localStorage.getItem('isPageHandler');
    if (val) {
      let parsed;
      try {
        parsed = JSON.parse(val);
      } catch {
        parsed = val === 'true' ? true : (val === 'false' ? false : (val === 'agency' ? 'agency' : (val === 'vessel' ? 'vessel' : 'crew')));
      }
      dispatch(updatePage(parsed));
    } else {
      localStorage.setItem('isPageHandler', JSON.stringify('crew'));
      dispatch(updatePage('crew'));
    }

    setActiveTab(4)
   let userProfile = JSON.parse(
      localStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`)
    ).profile;  
            if (userProfile?.user_type)
            {
              if(userProfile?.user_type?.toLowerCase() === 'external vendor'){
                setIsVendor(true);
                dispatch(updateFliter({ ...filterData, poStatus:null }));
                setActiveTab(100)
              }
              else{
                setIsVendor(false);
              }
            }
              setIsUserLoaded(true);
           dispatch(resetVendorFilter());
  }, []);
  useEffect(() => {
      let userProfile = JSON.parse(
        localStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`)
      ).profile;  
       let hasVendorRole= userProfile?.user_type?.toLowerCase() === 'external vendor'
      if (hasVendorRole === false && policies?.poPolicies?.canAccess === false) {
        history.push('/unauthorized');
      }
      else if (hasVendorRole && policies?.vendorDashboardPolicies?.canAccess === false)
       history.push('/unauthorized');
  
  }, [policies]);
  useEffect(() => {  
    const handleUnload = () => {
        localStorage.removeItem('isPageHandler');
    };
    window.addEventListener('unload', handleUnload);
    return () => {
      window.removeEventListener('unload', handleUnload);
    };
  }, []);
  const handleSearch = (value) => {
    setsearch(value);
    dispatch(updateFliter({ ...filterData, search: value }));
  };
  
  return (
    <>
      <div className="md:w-full">
        <Header currentPage="Purchase Order List" headerName="Synergy Kaas" />
        <div className="manning-wrapper">
          <SubHeader
            searchComponent={<SearchBar handleSearch={handleSearch} search={search} placeholder="Search (Minimum 4 Characters)" />}
            addButtonComponent={
              !isVendor && (policies?.poPolicies?.canEdit || policies?.VesselpoPolicies?.canEdit || policies?.agencyPoPolicies?.canEdit) ? (
                !(policies?.VesselpoPolicies?.canAccess || policies?.agencyPoPolicies?.canAccess) ? (
                  <ButtonComponent
                    handleClick={() => {
                      localStorage.setItem('isPageHandler', JSON.stringify('crew'));
                      dispatch(updatePage('crew'));
                      goToCreatePage();
                    }}
                    name="Create PO"
                    icon={plusIcon}
                  />
                ) : (
                  <CreatePOButton
                    canCreateCrew={!!policies?.poPolicies?.canEdit}
                    canCreateVessel={!!policies?.VesselpoPolicies?.canEdit}
                    canCreateAgency={!!policies?.agencyPoPolicies?.canEdit}
                    goToCreatePage={(type) => {
                      if (type === 'crew') {
                        localStorage.setItem('isPageHandler', JSON.stringify('crew'));
                        dispatch(updatePage('crew'));
                        goToCreatePage();
                      } else if (type === 'agency') {
                        localStorage.setItem('isPageHandler', JSON.stringify('agency'));
                        dispatch(updatePage('agency'));
                        history.push('/create-agency-po');
                      } else {
                        localStorage.setItem('isPageHandler', JSON.stringify('vessel'));
                        dispatch(updatePage('vessel'));
                        goToCreatePage();
                      }
                    }}
                  />
                )
              ) : null}
          dropdownSelect={isVendor?(<DropdownSelect setIsAssignedToMe={setIsAssignedToMe} />):null}
            downloadButton={!isVendor &&(
              <>
                {/* <Button
                  className="bg-white-light w-auto"
                  variant="outlined"
                  onClick={handlleExportCommited}
                  size="large"
                  hidden={policies?.poPolicies.canCommittedDownload === false}
                  rounded
                  disabled={exportCommitedPOsLoading}
                >
                  {exportCommitedPOsLoading && <CircularProgress size={24} className="button-progress" />}
                  Committed cost report
                </Button> */}
                {(policies?.poPolicies?.canCommittedDownload || policies?.poPolicies?.canExcelDownload) && (
                  <ExportCCVButton vesselPolicies={policies?.VesselpoPolicies?.canAccess} agencyPolicies={policies?.agencyPoPolicies?.canAccess} disabled={exportPOLoading || exportCommitedPOsLoading} policies={policies} onClickOption={(type) => {
                    if(type.includes('report')){
                      handlleExportCommited(type)
                    }else{
                      handlleExport(type)
                    }
                  }} />
                )}
              </>
            )}
            expenseFilter={(
              modal === true && (
              <PoFilter
                {...{
                  setModal,
                  modal,
                  filterData,
                  isVendor,
                  dispatch,
                  setActiveTab,
                  isCrewPage,
                  poListType
                }}
              />
              )
            )}
          />
          <div
          className="flex justify-between items-left full"
          style={{ borderBottom: '3px solid #f8b113' }}
          >
            {!isVendor &&(
              <ul className="flex justify-between text-base text-gray-500 font-bold">
              <li
              className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
              style={{ backgroundColor: activeTab === 4 ? '#F8B113' : '#F1F1F1' }}
              onClick={() => tabChange(4)}
              >
                Open PO
              </li>
              <li
              className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
              style={{ backgroundColor: activeTab === 5 ? '#F8B113' : '#F1F1F1' }}
              onClick={() => tabChange(5)}
              >
                  Closed PO
              </li>
              <li
              className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
              style={{ backgroundColor: activeTab === 7 ? '#F8B113' : '#F1F1F1' }}
              onClick={() => tabChange(7)}
              >
                  Paid PO
              </li>
              </ul>)}

              {isVendor &&(
              <ul className="flex justify-between text-base text-gray-500 font-bold">
              <li
              className={`short-close-tab-button ${activeTab === 100 ? 'active-101' : ''}`}
              onClick={() => {
                tabChange(100);
                setIsShortCloseCompleted(false);
              }}
              >
               Short Close Pending
              </li>
              <li
              className={`short-close-tab-button ${activeTab === 101 ? 'active-101' : ''}`}
              onClick={() => {
                tabChange(101);
                setIsShortCloseCompleted(true);
              }}
              >
                 Short Close Completed
              </li></ul>)}

      <div className="flex items-right justify-center items-center">
           {(policies?.poPolicies?.canAccess || policies?.VesselpoPolicies?.canAccess || policies?.agencyPoPolicies?.canAccess) && (
  <FormControl variant="outlined" className="po-type-form-control">
     <Select
      className="po-menu"
      value={poListType}
      onChange={(e) => {
        const value = e.target.value;
        dispatch(updatePage(value));
        localStorage.setItem('isPageHandler', JSON.stringify(value));
        dispatch(updateFliter({
          ...filterData,
          expenseCategoryId: null,
          expenseCategoryName: null
        }));
      }}
      name="poTypeSelect"
      displayEmpty
      renderValue={(v) => {
        if (v === 'crew') return 'Crew PO';
        if (v === 'agency') return 'Agency PO';
        return 'Vessel PO';
      }}
      MenuProps={{
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        getContentAnchorEl: null,
        PaperProps: { className: 'po-menu-paper' },
        MenuListProps: { className: 'po-menu-list' },
      }}
    >
      {policies?.poPolicies?.canAccess && <MenuItem value="crew">Crew PO</MenuItem>}
      {policies?.VesselpoPolicies?.canAccess && <MenuItem value="vessel">Vessel PO</MenuItem>}
      {policies?.agencyPoPolicies?.canAccess && <MenuItem value="agency">Agency PO</MenuItem>}
    </Select>
  </FormControl>
)}

    
    <FilterComponent {...{ setModal }} />
    </div>
    </div>
          {isUserLoaded && (
          <PoTableComponent
            {...{
              filterData,
              policies,
              search,
              isVendor,
              isAssignedToMe,
              isShortCloseCompleted,
              isCrewPage,
              poListType
            }}
          />
          )}
        </div>
      </div>
      <Modal
        open={filterModal}
        onClose={() => setFilterModal(false)}
        closeOnOverlayClick={false}
        center
        showCloseIcon={false}
        styles={deleteModalStyles}
      >
        <div className="w-auto py-8 px-8 ">
          <div className="align-middle align-center text-center">
            <h2 className="uppercase text-center pb-8">Confirm Export</h2>
          {exportValue === 'csv' && (<div className="font-normal pb-8">All POs in the application will get exported.</div>)}
          {exportValue === 'ccr' && (<div className="font-normal pb-8">All Open POs in the application will get exported.</div>)}
            <div className="font-normal pb-8">Do you still wish to continue ?</div>
            <div className="flex justify-evenly">
              <Button
                className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
                onClick={() => setFilterModal(false)}
                size="large"
                variant="outlined"
                rounded
              >
                Cancel
              </Button>

              <Button
                className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
                onClick={() => {
                  setFilterModal(false);
                  if (exportValue === 'csv') {
                     exportPo();
                    setExportValue('');
                    } else if (exportValue === 'ccr') {
                    exportCommitedPo();
                    setExportValue('');
                  }
                }}
                size="large"
                variant=" filled"
                rounded
              >
                Export
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ManningPOBasePage;
